module.exports = __webpack_public_path__ + "img/bianji-2.4058c3fe.png";